/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const XIcon = createIcon({
    displayName: 'XIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "m13.49 11.017 5.828-6.775h-1.381l-5.061 5.882-4.042-5.882H4.172l6.112 8.895-6.112 7.105h1.381l5.344-6.213 4.27 6.213h4.661l-6.339-9.225Zm-1.892 2.199-.62-.886-4.927-7.05h2.121l3.977 5.689.62.885 5.168 7.394h-2.121l-4.218-6.033Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "m14.093 10.27 8.19-9.52h-1.94L13.23 9.016 7.55.75H1l8.589 12.5L1 23.233h1.94l7.51-8.729 5.999 8.73H23L14.092 10.27h.001Zm-2.658 3.09-.87-1.244L3.64 2.21h2.981l5.588 7.993.87 1.245 7.264 10.39h-2.98l-5.928-8.478Z"
        })
    ]
});
XIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'XIcon'
};
export { XIcon };

//# sourceMappingURL=x.js.map